import { QRVALUE_ACTION_TYPES } from '../actionTypes';
import { qrValue } from '../sagas/ForgeRockSagas';

// reducer with initial state
const initialState = {
  qr_loading: false,
  qrValue: null,
  qr_error: null,
};

const qrAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case QRVALUE_ACTION_TYPES.POST.IN_PROGRESS:
      return { ...state, qr_loading: true, qr_error: null };
    case QRVALUE_ACTION_TYPES.POST.SUCCESS:
      return { ...state, qr_loading: false, qrValue: action.payload };
    case QRVALUE_ACTION_TYPES.POST.ERROR:
      return {
        ...state,
        qr_loading: false,
        qrValue: null,
        qr_error: action.error,
      };
    default:
      return state; // return initial state by default
  }
};

export default qrAuthReducer;
